export default __webpack_public_path__ + "static/media/rgs_mobile_small@2x.8fea4852.jpg";